import { render, staticRenderFns } from "./LayoutHeaderNavigation.vue?vue&type=template&id=ba9d97ec&scoped=true&lang=pug"
import script from "./LayoutHeaderNavigation.vue?vue&type=script&lang=js"
export * from "./LayoutHeaderNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9d97ec",
  null
  
)

export default component.exports